import { render, staticRenderFns } from "./layer-relation-publish.vue?vue&type=template&id=2413f001&scoped=true&"
import script from "./layer-relation-publish.vue?vue&type=script&lang=js&"
export * from "./layer-relation-publish.vue?vue&type=script&lang=js&"
import style0 from "./layer-relation-publish.vue?vue&type=style&index=0&id=2413f001&lang=scss&scoped=true&"
import style1 from "./layer-relation-publish.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2413f001",
  null
  
)

export default component.exports